import { BaseMapper } from '@ps/utils';

import { LoginDto } from '../dtos/auth.dto';
import { User } from '../../models/user.model';

// Inbound mapper — maps API response DTOs to domain models.
// Direction: API DTO → Domain model
export class AuthMapper extends BaseMapper<LoginDto, User> {
  public fromDto(dto: LoginDto): User {
    const { user, token, churnZeroKey } = dto;

    return {
      id: user.id,
      accessLevel: user.accessLevel,
      address: user.addr,
      buyerAccessLevel: user.buyerAcssLvls,
      churnZeroKey,
      companyId: user.cmp,
      createdOn: user.crtd_on,
      email: user.eml,
      hasConsolidatedView: user.consolidate_view,
      isApiUser: user.isApiUser,
      isBuyerUser: user.buyerUser,
      lastActiveTime: user.lastActiveTime,
      lastLoggedIn: user.lastLogin,
      modifiedOn: user.mod_on,
      operatorAccessLevel: user.operatorAcssLvls,
      questionLibraryAccessLevel: user.questionLibraryAccessLevel,
      selectedDashboardView: user.selectedDashboardView && {
        option: user.selectedDashboardView.option,
        productManagerId: user.selectedDashboardView.pmId,
      },
      status: user.st,
      supplierAccessLevel: user.supplierAcssLvls,
      termsOfService: user.tos && {
        accepted: user.tos.accept,
        acceptedTS: user.tos.acceptTS,
      },
      token,
      userName: user.usrName,
    };
  }
}
